import React, {Component} from 'react'
import {Button} from 'antd'
import AddPartnerModal from './AddPartnerModal'

class AddPartner extends Component {
    state = {
        isOpen: false,
    }

    _showModal = () => {
        this.setState({
            isOpen: true,
        })
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    render() {
        const {isOpen} = this.state

        return (
            <div className="AddPartner">
                <Button type="primary" onClick={this._showModal}>
                    Tạo đối tác
                </Button>
                <AddPartnerModal isOpen={isOpen} onClose={this._closeModal}/>
            </div>
        )
    }
}

export default AddPartner